<template>
  <v-layout justify-center class="white">
    <v-flex xs12 sm10 md10 justify-center>
      <v-layout>
        <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
        </v-flex>
        <v-flex xm12 md4 class="text-sm-center">
          <span class="headline">Contact List</span><br />
        </v-flex>
      </v-layout>

      <v-card>
        <v-card-text>
          <vue-good-table
            ref="my-table"
            styleClass="vgt-table striped bordered"
            :max-height=this.height
            :fixed-header="true"
            :isLoading=this.isTableLoading
            :columns="columns"
            :rows="rows"
            :search-options="{
              enabled: true
            }">
            <template slot="loadingContent">
              <div>
                <v-progress-circular
                  :size="50"
                  :width="7"
                  color="blue"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
            <div slot="table-actions-bottom">
              <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
            </div>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'name'">
                <v-layout align-center justify-start row fill-height>
                  <v-flex xs12>
                    {{ props.row.firstName }} {{ props.row.lastName }}<br /> ({{ props.row.type }})
                  </v-flex>
                </v-layout>
              </span>
              <span v-if="props.column.field == 'phone'">
                <v-layout align-center justify-start row fill-height>
                  <v-flex xs12>
                    {{ props.row.phone }}<br /> {{ props.row.mobile }}
                  </v-flex>
                </v-layout>
              </span>
              <span v-else-if="props.column.field == 'email'">
                <v-layout align-center justify-start row fill-height>
                  <v-flex xs12>
                    <a :href="'mailto:' + props.row.email" style="text-decoration: none;">
                      {{ props.row.email }}
                    </a>
                  </v-flex>
                </v-layout>
              </span>
              <span v-else-if="props.column.field == 'actions'">
                <div class="text-xs-center">
                  <v-avatar
                    v-if="isAdmin"
                    color="blue lighten-4"
                    class="mr-2 mt-2"
                    size="30"
                    style="cursor: pointer;"
                    @click="editItem(props)"
                  >
                    <v-icon small>edit</v-icon>
                  </v-avatar>
                </div>
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </vue-good-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="newItem">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-dialog v-model="dialog" max-width="500px">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card >
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="closeThisEval">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add/Edit Contact</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
              <v-btn dark flat @click="save">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout class="pb-3" row wrap>
                <v-flex xs12>
                  <v-select
                    :items="contactTypes"
                    v-model="evalItem.type"
                    label="Type"
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.firstName"
                    @keyup.enter="save"
                    label="First Name"
                    :rules="[v => !!v || 'First Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.lastName"
                    @keyup.enter="save"
                    label="Last Name"
                    :rules="[v => !!v || 'Lasty Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.title"
                    @keyup.enter="save"
                    label="Title"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="evalItem.phone"
                    @keyup.enter="save"
                    label="Phone"
                    mask="(###) ###-####"
                    return-masked-value
                    :rules="[v => !!v || 'Primary Phone is required']"
                    prepend-icon="phone"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="evalItem.mobile"
                    @:keyup.enter="save"
                    label="Mobile"
                    mask="(###) ###-####"
                    return-masked-value
                    prepend-icon="stay_current_portrait"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="evalItem.fax"
                    @:keyup.enter="save"
                    label="Fax"
                    prepend-icon="mdi-fax"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.email"
                    @keyup.enter="save"
                    label="Email Address"
                    prepend-icon="email"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import XLSX from 'xlsx'

export default {
  props: ['item'],

  components: {
    VueGoodTable
  },

  data () {
    return {
      myId: this.$store.state.user.id,
      page: 'list',
      valid: true,
      searchSelect: [],
      searchType: '',
      currentYear: 0,
      isAdmin: this.$store.state.isAdmin,
      isCommChair: false,
      dialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'Name/Type',
          field: 'name',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Phone/Mobile',
          field: 'phone',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Email',
          field: 'email',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          html: true
        },
        {
          label: 'Action',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      committeeHeader: {},
      rows: [],
      editedItem: {},
      evalItem: {},
      liason: {},
      showEmailForm: false,
      showEvalForm: false,
      emails: [],
      cc: [],
      bcc: [],
      emailList: [],
      ccList: [],
      bccList: [],
      emailText: '',
      memberList: [],
      contactTypes: ['Contact', 'Secondary', 'Billing', 'Primary Onsite', 'Secondary Onsite']
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear
    this.searchType = this.$store.state.currentYear
    this.yearList()

    if (this.$route.params.currentYear) {
      this.currentYear = this.$route.params.currentYear
    } else {
      this.currentYear = this.$store.state.currentYear
    }

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getContacts()

    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    '$route.params.committee': function (committee) {
      this.isTableLoading = true
      this.loading = true

      this.getVendors()
      this.loading = false
    }
  },

  methods: {
    yearList () {
      for (let i = this.$store.state.currentYear; i >= 2013; i--) {
        this.searchSelect.push(i)
      }
    },

    async getMembers () {
      let allUsers = 'users'

      try {
        const response = await Api().get(allUsers)
        this.memberList = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 600
      this.height = height + 'px'
    },

    newItem () {
      this.evalItem = {}
      this.dialog = true
    },

    editItem (props) {
      this.evalItem = props.row
      this.dialog = true
    },

    save () {
      // if (this.$refs.form.validate()) {
      if (this.evalItem.id > 0) {
        // console.log('Update')
        this.updateItem(this.editedItem)
      } else {
        // console.log('Save')
        this.addItem(this.editedItem)
      }
      // } else {
      //   this.snackbar.message = 'You have some errors on the page!'
      //   this.snackbar.color = 'error'
      //   this.snackbar.show = true
      // }
    },

    async addItem () {
      try {
        this.evalItem.VendorCompanyId = this.item.id
        const response = await Api().post('vendor_contacts', this.evalItem)
        const contact = response.data.contact

        //   let name = this.committeeList.find(item => item.value === this.editedCommittee.committeeId)
        //   this.loadCommittee.name = name.text
        //   this.loadCommittee.title = this.editedCommittee.title
        //   this.loadCommittee.year = this.currentYear
        //   this.loadCommittee.id = this.editedCommittee.committeeId

        //   this.userCommittees.push(this.loadCommittee)
        this.rows.push(contact)

        //   setTimeout(() => {
        //     this.editedCommittee = Object.assign({}, this.defaultCommittee)
        //     this.loadCommittee = Object.assign({}, this.loadDefaultCommittee)
        //   }, 300)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      try {
        const response = await Api().put('vendor_contacts/' + this.evalItem.id, this.evalItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteItem (committeeId) {
      let r = confirm('Are you sure you want to remove this committee?')

      if (r === true) {
        try {
          const response = await Api().delete('vendor_contacts/' + this.evalItem.id)

          this.rows.splice(this.editedIndex, 1)
          this.close()

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async getContacts () {
      this.isCommChair = false

      try {
        const response = await Api().get('vendor_contacts/' + this.item.id)

        this.rows = response.data

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    searchYear () {
      this.currentYear = this.searchType
      this.getVendors()
    },

    async buildPdf (itemId) {
      try {
        const response = await Api().delete('animals/' + itemId)
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    buildEmail () {
      for (let i in this.rows) {
        this.emailList[i] = this.rows[i].name + ' <' + this.rows[i].email + '>'
      }
      this.ccList = this.emailList
      this.bccList = this.emailList

      for (let i in this.$refs['my-table'].selectedRows) {
        this.emails[i] = this.$refs['my-table'].selectedRows[i].name + ' <' + this.$refs['my-table'].selectedRows[i].email + '>'
      }

      this.showEmailForm = true

      if (this.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    onExport () {
      this.printMembers = this.rows.map(a => ({
        'Name': a.name,
        'Address': a.address,
        'City': a.city,
        'State': a.state,
        'Zip': a.zip,
        'Primary Phone': a.primaryPhone,
        'Secondayr Phone': a.secondaryPhone,
        'Email': a.email,
        'Age': a.age,
        'Height': a.height,
        'Weight': a.weight,
        'Parents': a.parents,
        'Notes': a.notes
      }))

      let membersWS = XLSX.utils.json_to_sheet(this.printMembers)

      let wb = XLSX.utils.book_new()

      if (!wb.Props) { wb.Props = {} }
      wb.Props.Title = 'Insert Title Here'

      XLSX.utils.book_append_sheet(wb, membersWS, this.committeeHeader.committeeCode)

      XLSX.writeFile(wb, this.currentYear + ' Mutton Busters.xlsx')
    },

    remove (item) {
      // console.log(item)
      this.emails.splice(this.emails.indexOf(item), 1)
      this.emails = [...this.emails]
    },

    closeThis (item) {
      this.emails = []
      this.showEmailForm = false
    },

    closeThisEval (item) {
      // const evalmem = item
      // let index = this.rows.findIndex(row => row.id === evalmem.UserId)
      // this.rows[index].eval = evalmem
      this.evalItem = {}
      this.dialog = false
    },

    close () {
      this.initialImage = null
      this.dialog = false
      this.showEmailForm = false
      this.showEvalForm = false
      this.qrDialog = false

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/ContactList.vue